module.exports = __webpack_public_path__ + "img/Jarrell James.38813abc.jpg";